import { File } from '../file';
import { InternServiceLink } from '../intern/service-link';

/**
 * Model definition for ContactBox
 */
export interface ContentContactBox {
  __component: 'content.contact-box';
  id: string;
  headline: string;
  subline: string;
  image: File;
  layout: 'imageRight' | 'imageLeft';
  phoneNumber?: string;
  mailLink?: InternServiceLink;
  chatLink?: InternServiceLink;
}

export function isContentContactBox(obj: { __component?: string }): obj is ContentContactBox {
  return obj.__component === 'content.contact-box';
}
